<template>
  <div class="onlineHelp" :class="{'isiOSX':isiOSX}">
    <van-nav-bar title="在线帮助" @click-left="goBack" left-arrow/>
    <div class="help-content">
	    <div>
		    <van-row class="xb-row">
		      <van-col class="xb-content" span="24">
		        <img class="xb-image" src="../../assets/help/xb-help.png" alt>
		        <span class="xb-server">您好，我是小巴同学，很高兴为您服务!</span>
		        <img class="xb-gift" src="../../assets/help/pig-image.png" alt>
		      </van-col>
		    </van-row>
	    </div>
	    <div class="moreProblem">
	      <span class="xb-more-problem">常见问题</span>
	      <div class="description" v-for="item in list" @click="showpoints(item.id)">{{item.name}}</div>
	    </div>
    </div>
    <div class="servise" @click="chat()">
    	<img src="../../assets/help/customer.png"/>
    	<p>联系客服</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
//    show: false,
	    list: [],
	    anwser: [],
	    isiOSX: false
    };
  },
  created(){
		this.$api.setToken(this.$route.query.token)
		this.isiOSX = this.isIphoneX();
　　	this.getInfo();
	},
  methods: {
  	getInfo() {
    	var ID = this.$route.query.id
    	this.$api.get("/cms/member/help/category/first").then(res => {
	        this.list = res.list;
	    });
    },
    showpoints(id) {
    	this.$router.push({
	      path: "/second",
	      query: {
	        id: id
	      }
    	});
      
    },
    hidepoints(){
      this.show=false;
    },
    chat() {
    	this.params('', '','chat');
    },
    goBack() {
    	this.params('', '','goBack');
    }
  }
};
</script>
<style lang='less' scoped>
.onlineHelp {
  background-color: #f2f2f2;
  height: 100%;
  .van-nav-bar {
    background: #f2f2f2;
    padding-top: 24px;
    position: fixed;
    width: 100%;
    .van-nav-bar__title {
      font-size: 18px;
      color: #333;
    }
    .van-icon-arrow-left:before {
      display: none;
    }
    .van-nav-bar__left {
      left: 11px;
      .van-icon {
        width: 17px;
        height: 15px;
        display: inline-block;
        background: url(../../assets/plane/reBack.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
	.help-content {
		padding-top: 70px;
	  	background-color: #f2f2f2;
	  	box-sizing: border-box;
		height: 100%;
	    overflow-y: scroll;
	    -webkit-overflow-scrolling:touch;
	  .xb-row {
	    height: 90px;
	    background: -webkit-linear-gradient(
	      #febc89,
	      #fe655a
	    ); /* Safari 5.1 - 6.0 */
	    background: -o-linear-gradient(#febc89, #fe655a); /* Opera 11.1 - 12.0 */
	    background: -moz-linear-gradient(#febc89, #fe655a); /* Firefox 3.6 - 15 */
	    background: linear-gradient(#febc89, #fe655a); /* 标准的语法 */
	    .xb-content {
	      position: relative;
	      .xb-image {
	        position: absolute;
	        left: 38px;
	        top: 14px;
	      }
	      @media screen and (max-width: 320px){
	      	.xb-image {
					    left: 20px;
					}
	      }
	      .xb-server {
	        position: absolute;
	        display: inline-block;
	        width: 163px;
	        line-height: 16px;
	        font-weight: 500;
	        font-size: 12px;
	        color: #fff;
	        left: 58px;
	        top: 26px;
	      }
	      @media screen and (max-width: 320px){
	      	.xb-server {
					    left: 40px;
					}
	      }
	      .xb-gift {
	        position: absolute;
	        right: 42px;
	        top: 7px;
	      }
	      @media screen and (max-width: 320px){
	      	.xb-gift {
					    right: 14px;
					}
	      }
				
	    }
	  }
	  .xb-problem {
	    background: #fff;
	    width: 93.6%;
	    margin: -13px auto 7px auto;
	    z-index: 1;
	    border-radius: 10px;
	    box-shadow: 0px 2px 4px 0px rgba(227, 227, 227, 0.4);
	    overflow: hidden;
	    .problem {
	      font-size: 14px;
	      color: #333333;
	      display: inline-block;
	      margin: 15px 0 22px 12px;
	      font-weight: bold;
	    }
	    .xb-common {
	      margin: 0 25px 20px 25px;
	      text-align: center;
	      span {
	        display: block;
	        font-size: 12px;
	        color: #333333;
	        margin-top: 15px;
	      }
	      .agent {
	        margin-top: 12px;
	      }
	    }
	  }
	  .moreProblem {
	    background: #fff;
	    width: 93.6%;
	    margin: 0 auto;
	    margin-top: -13px;
	    border-radius: 10px;
	    box-shadow: 0px 2px 4px 0px rgba(227, 227, 227, 0.4);
	    padding: 0 13px 0 12px;
	    box-sizing: border-box;
	    overflow: hidden;
	    .xb-more-problem {
	      display: block;
	      font-size: 14px;
	      font-weight: bold;
	      color: #333333;
	      margin-top: 20px;
	    }
	    div {
	      font-size: 12px;
	      color: #333333;
	    }
	    .description {
	      line-height: 15px;
	      padding: 20px 0px;
	      border-bottom: 1px solid #f2f2f2;
	    }
	    .description:nth-child(1) {
	      padding: 24px 0 20px 0;
	    }
	  }
  }
  .servise {
  	width: 58px;
  	height: 76px;
  	position: fixed;
  	bottom:49px;
		right: 21px;
  	img {
  		width: 58px;
  		display: block;
  	}
  	p {
  		color: #333333;
  		font-size: 13px;
  		height: 18px;
  		line-height: 18px;
  		text-align: center;
  	}
  }
}

  .isiOSX {
  	.van-nav-bar {
  		padding-top: 43px;
  	}
		.help-content {
			padding-top: 90px;
		}
	}

@media screen and (max-width: 320px) {
  .xb-image {
    left: 20px;
  }
  .xb-server {
    left: 40px;
  }
  .xb-gift {
    right: 14px;
  }
}
@media screen and (max-width: 375px) and (min-width: 321px) {
  .xb-image {
    left: 38px;
  }
  .xb-server {
    left: 58px;
  }
  .xb-gift {
    right: 42px;
  }
}
@media screen and (min-width: 376px) and (max-width: 414px) {
  .xb-image {
    left: 65px;
  }
  .xb-server {
    left: 82px;
  }
  .xb-gift {
    right: 60px;
  }
}
@media screen and (min-width: 768px) {
  .xb-image {
    left: 220px;
  }
  .xb-server {
    left: 240px;
  }
  .xb-gift {
    right: 250px;
  }
}
</style>



